import { GET_DEVICE_STATUS_HISTORY, GET_HISTORICAL_EARNINGS } from '../graphql/queries';
import { GET_ADMIN_DASHBOARD_DATA } from '../graphql/query/adminDashboard';
import { formatDateWithTimeWithSeconds } from '../utils/helper';
import { client } from './apolloClient';

export type IAdminDashboardData = {
    device_status: {
        active: number;
        inactive: number;
        poweroff: number;
    };
    earnings: {
        current_month: number;
        lifetime: number;
    };
    gpu: {
        current_month: number;
        devices_count: number;
    };
    temperature: {
        current_month: number;
        devices_count: number;
    };
};
export type IGpuStateData = {
    year: number;
    month: number;
    gpu_utilization: number;
    earnings: number;
};

export type IConnectivityData = {
    createdAt: string;
    status: string;
    sensor_timestamp: string;
};

export const fetchAdminDashboardData = async (): Promise<any | null> => {
    try {
        const { data } = await client.query({
            query: GET_ADMIN_DASHBOARD_DATA,
            fetchPolicy: 'network-only',
        });
        const tempData = data?.getAdminDashboard;
        if (!tempData) throw new Error('No data found');
        return tempData;
    } catch (error) {
        console.error('Error fetching admin dashboard:', error);
        throw error;
    }
};

export const fetchDashboardGpuState = async (deviceId: string) => {
    if (!deviceId) return [];
    try {
        const { data } = await client.query({
            query: GET_HISTORICAL_EARNINGS,
            variables: { deviceId },
            fetchPolicy: 'network-only',
        });
        if (!data?.getDeviceHistoricalEarnings && !data?.getDeviceHistoricalEarnings?.last_6_months_earnings) {
            return [];
        }
        const formattedRows = data?.getDeviceHistoricalEarnings?.last_6_months_earnings.map(
            ({ gpu_utilization, earnings, month, year }: IGpuStateData, index: number) => ({
                id: index,
                gpu_utilization: `${gpu_utilization}%`,
                earnings: earnings && typeof earnings === 'number' ? `$${earnings?.toFixed(2) || 0}` : `$0`,
                month: `${month}, ${year}`,
            }),
        );
        return formattedRows;
    } catch (error) {
        console.error('Error fetching  details:', error);
        throw error;
    }
};

export const fetchDashboardConnectivityState = async (deviceId: string) => {
    try {
        const { data } = await client.query({
            query: GET_DEVICE_STATUS_HISTORY,
            variables: { deviceId },
            fetchPolicy: 'network-only',
        });

        if (!data?.getCustomerDeviceStatusHistory) return [];
        const formattedRows = data.getCustomerDeviceStatusHistory.map(
            ({ status, sensor_timestamp }: IConnectivityData, index: number) => ({
                id: index,
                date: formatDateWithTimeWithSeconds(sensor_timestamp),
                status,
            }),
        );
        return formattedRows;
    } catch (error) {
        console.error('Error fetching  details:', error);
        throw error;
    }
};
